import loadable from '@/utils/loadable';

export const HomePage = loadable(() => import('@/pages/Home'));
export const SportsPage = loadable(() => import('@/pages/Sports'));
export const MarketsPage = loadable(() => import('@/pages/Markets'));
export const CasinoPage = loadable(() => import('@/pages/Casino'));
export const QTECHLobbyPage = loadable(() => import('@/pages/QTECHLobby'));
export const AccountStatementPage = loadable(() => import('@/pages/AccountStatment'));
export const CasinoPlaygroundPage = loadable(() => import('@/pages/CasinoPlayground'));
export const BetHistoryPage = loadable(() => import('@/pages/BetHistory'));
export const ActivityLogsPage = loadable(() => import('@/pages/ActivityLog'));
export const CasinoResultsPage = loadable(() => import('@/pages/CasinoResults'));
export const CasinoBetHistoryPage = loadable(() => import('@/pages/CasinoBetHistory'));
export const AuthVerificationPage = loadable(() => import('@/pages/AuthVerification'));
export const ChangePasswordPage = loadable(() => import('@/pages/ChangePassword'));
export const TermsConditionsPage = loadable(() => import('@/pages/TermsAndConditions'));
export const LiveCasinoBetsPage = loadable(() => import('@/pages/LiveCasinoBets'));
export const DepositPage = loadable(() => import('@/pages/Deposit'));
export const WithdrawPage = loadable(() => import('@/pages/Withdraw'));
export const ReferralPage = loadable(() => import('@/pages/Referral'));
export const BonusStatementPage = loadable(() => import('@/pages/BonusStatement'));
export const ProfilePage = loadable(() => import('@/pages/Profile'));
export const RulesPage = loadable(() => import('@/pages/Rules'));
export const OffersPage = loadable(() => import('@/pages/Offers'));
export const TransactionReportPage = loadable(() => import('@/pages/TransactionReport'));
